import { a as r } from "../internals/array-buffer-view-core.js";
var t = r.aTypedArray,
  e = r.exportTypedArrayMethod,
  a = Math.floor;
e("reverse", function () {
  for (var r, e = t(this).length, i = a(e / 2), s = 0; s < i;) r = this[s], this[s++] = this[--e], this[e] = r;
  return this;
});